// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================================================================
 * Shared design tokens + utility classes
 * Loaded globally from index.js. Defines CSS custom properties so we
 * can stop hard-coding colors/spacing/typography per page.
 * ================================================================= */

:root {
  /* Brand */
  --color-primary:        #5865F2;
  --color-primary-hover:  #4752c4;
  --color-primary-soft:   rgba(88, 101, 242, 0.15);

  /* Semantic */
  --color-success:        #43b581;
  --color-success-hover:  #3ca374;
  --color-warning:        #faa61a;
  --color-danger:         #ef4444;
  --color-danger-hover:   #dc2626;
  --color-info:           #00b0f4;

  /* Surfaces */
  --surface-0: #0f0f1e;          /* app bg */
  --surface-1: #16213e;          /* cards */
  --surface-2: #1a1a2e;          /* modals */
  --surface-3: #23233a;          /* inputs */
  --surface-hover: #2a2a45;

  /* Text */
  --text-primary:   #ffffff;
  --text-secondary: #b9b9c8;
  --text-muted:     #8b8b9a;

  /* Borders */
  --border-subtle: rgba(255, 255, 255, 0.08);
  --border-strong: rgba(255, 255, 255, 0.16);

  /* Spacing scale */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;

  /* Radii */
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;

  /* Shadows */
  --shadow-sm: 0 2px 6px rgba(0, 0, 0, 0.18);
  --shadow-md: 0 4px 14px rgba(0, 0, 0, 0.28);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.38);

  /* Typography */
  --font-size-xs:  0.75rem;
  --font-size-sm:  0.875rem;
  --font-size-md:  1rem;
  --font-size-lg:  1.125rem;
  --font-size-xl:  1.5rem;
  --font-size-2xl: 1.75rem;

  /* Focus ring */
  --focus-ring: 0 0 0 3px rgba(88, 101, 242, 0.45);
}

/* =================================================================
 * Focus visible — keyboard navigation needs to be visible
 * ================================================================= */
*:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
  border-radius: 4px;
}
button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

/* =================================================================
 * Buttons — consolidated; legacy page-specific styles may still
 * override, which is fine during gradual migration.
 * ================================================================= */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease, transform 0.05s ease;
  min-height: 2.25rem;
}
.btn:disabled,
.btn[aria-disabled="true"] {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-primary       { background: var(--color-primary); color: #fff; }
.btn-primary:hover:not(:disabled)       { background: var(--color-primary-hover); }
.btn-success       { background: var(--color-success); color: #fff; }
.btn-success:hover:not(:disabled)       { background: var(--color-success-hover); }
.btn-danger        { background: var(--color-danger); color: #fff; }
.btn-danger:hover:not(:disabled)        { background: var(--color-danger-hover); }
.btn-secondary     { background: var(--surface-3); color: var(--text-primary); }
.btn-secondary:hover:not(:disabled)     { background: var(--surface-hover); }
.btn-ghost         { background: transparent; color: var(--text-secondary); }
.btn-ghost:hover:not(:disabled)         { background: var(--surface-hover); color: var(--text-primary); }
.btn-sm            { padding: var(--space-1) var(--space-3); font-size: var(--font-size-xs); min-height: 1.75rem; }
.btn-lg            { padding: var(--space-3) var(--space-6); font-size: var(--font-size-md); min-height: 2.75rem; }
.btn-block         { width: 100%; }

/* =================================================================
 * Shared data-table — previously used in 8+ pages but never defined.
 * ================================================================= */
.data-table-container {
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  margin-bottom: var(--space-6);
}
.data-table-container > .data-table-scroll {
  width: 100%;
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-sm);
}
.data-table thead th {
  background: rgba(0, 0, 0, 0.25);
  text-align: left;
  padding: var(--space-3) var(--space-4);
  font-weight: 600;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-subtle);
  white-space: nowrap;
}
.data-table tbody td {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
  color: var(--text-primary);
  vertical-align: top;
}
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover td { background: rgba(88, 101, 242, 0.05); }
.data-table .col-actions { white-space: nowrap; width: 1%; }

@media (max-width: 768px) {
  .data-table thead { display: none; }
  .data-table tbody tr {
    display: block;
    padding: var(--space-3);
    border-bottom: 1px solid var(--border-subtle);
  }
  .data-table tbody td {
    display: flex;
    justify-content: space-between;
    padding: var(--space-2) 0;
    border: none;
  }
  .data-table tbody td::before {
    content: attr(data-label);
    color: var(--text-muted);
    font-weight: 600;
    margin-right: var(--space-4);
  }
}

/* =================================================================
 * Shared form controls — used as a baseline for new pages.
 * ================================================================= */
.shared-form-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-bottom: var(--space-4);
}
.shared-form-label {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text-secondary);
}
.shared-form-control {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  background: var(--surface-3);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-family: inherit;
  min-height: 2.25rem;
}
.shared-form-control:focus {
  border-color: var(--color-primary);
  outline: none;
}
textarea.shared-form-control { min-height: 6rem; resize: vertical; }
.shared-form-error {
  color: var(--color-danger);
  font-size: var(--font-size-xs);
  margin-top: var(--space-1);
}
.shared-form-hint {
  color: var(--text-muted);
  font-size: var(--font-size-xs);
}
.shared-form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--space-4);
}

/* =================================================================
 * Shared modal — for pages that don't have bespoke modal CSS.
 * ================================================================= */
.shared-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--space-4);
  animation: sharedModalFadeIn 0.15s ease-out;
}
.shared-modal {
  background: var(--surface-2);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  padding: var(--space-6);
}
.shared-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-5);
}
.shared-modal-header h2 { font-size: var(--font-size-xl); color: var(--text-primary); }
.shared-modal-close {
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
}
.shared-modal-close:hover { color: var(--text-primary); background: var(--surface-hover); }
.shared-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  margin-top: var(--space-5);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-subtle);
}
.shared-form-error-banner {
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: #fecaca;
  padding: var(--space-3);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-4);
  font-size: var(--font-size-sm);
}

@keyframes sharedModalFadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* =================================================================
 * Toast system
 * ================================================================= */
.toast-container {
  position: fixed;
  top: var(--space-6);
  right: var(--space-6);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  z-index: 2000;
  pointer-events: none;
  max-width: calc(100vw - var(--space-6) * 2);
}
.toast {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  background: var(--surface-2);
  color: var(--text-primary);
  border-left: 4px solid var(--color-primary);
  border-radius: var(--radius-md);
  padding: var(--space-3) var(--space-4);
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
  min-width: 260px;
  max-width: 460px;
  animation: toastSlideIn 0.18s ease-out;
}
.toast-success { border-left-color: var(--color-success); }
.toast-error   { border-left-color: var(--color-danger); }
.toast-warning { border-left-color: var(--color-warning); }
.toast-info    { border-left-color: var(--color-info); }
.toast-message { flex: 1 1; font-size: var(--font-size-sm); line-height: 1.35; }
.toast-close {
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;
  padding: 0 var(--space-1);
}
.toast-close:hover { color: var(--text-primary); }

@keyframes toastSlideIn {
  from { opacity: 0; transform: translateX(16px); }
  to   { opacity: 1; transform: translateX(0); }
}

@media (max-width: 768px) {
  .toast-container {
    top: auto;
    bottom: var(--space-4);
    right: var(--space-4);
    left: var(--space-4);
  }
  .toast { max-width: none; }
}

/* =================================================================
 * ErrorBoundary + 404
 * ================================================================= */
.error-boundary,
.not-found-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-8);
}
.error-boundary-inner,
.not-found-inner {
  max-width: 560px;
  text-align: center;
  background: var(--surface-1);
  padding: var(--space-8);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-subtle);
}
.error-boundary-inner h1,
.not-found-inner h1 {
  font-size: var(--font-size-2xl);
  margin-bottom: var(--space-4);
  color: var(--text-primary);
}
.error-boundary-inner p,
.not-found-inner p {
  color: var(--text-secondary);
  margin-bottom: var(--space-5);
  line-height: 1.5;
}
.error-boundary-inner details {
  margin: var(--space-4) 0;
  text-align: left;
}
.error-boundary-inner summary {
  cursor: pointer;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}
.error-boundary-inner pre {
  background: var(--surface-0);
  padding: var(--space-3);
  border-radius: var(--radius-sm);
  overflow-x: auto;
  font-size: var(--font-size-xs);
  margin-top: var(--space-2);
  color: var(--text-secondary);
}

/* =================================================================
 * Utility — inline error text under forms
 * ================================================================= */
.inline-error {
  color: var(--color-danger);
  font-size: var(--font-size-sm);
  margin-top: var(--space-2);
}
.inline-success {
  color: var(--color-success);
  font-size: var(--font-size-sm);
  margin-top: var(--space-2);
}

/* =================================================================
 * Page-level empty / loading state helpers
 * ================================================================= */
.page-empty-state {
  text-align: center;
  padding: var(--space-8);
  color: var(--text-muted);
  background: var(--surface-1);
  border-radius: var(--radius-lg);
  border: 1px dashed var(--border-subtle);
}
.page-loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-8);
  color: var(--text-muted);
}

/* Accessible visually-hidden helper for screen readers */
.visually-hidden {
  position: absolute;
  width: 1px; height: 1px;
  padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0, 0, 0, 0);
  white-space: nowrap; border: 0;
}

/* =================================================================
 * Styles used by the 18 pages without dedicated CSS files.
 * These ensure the pages render consistently even though they
 * don't import their own stylesheet.
 * ================================================================= */

/* --- Aftercare / Mood comparison --- */
.aftercare-list { display: flex; flex-direction: column; gap: var(--space-4); }
.mood-comparison { display: flex; align-items: center; gap: var(--space-3); flex-wrap: wrap; margin: var(--space-3) 0; }
.mood-item { flex: 1 1; min-width: 100px; }
.mood-label { font-size: var(--font-size-xs); color: var(--text-muted); display: block; margin-bottom: var(--space-1); }
.mood-change-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-1) var(--space-2);
  font-size: var(--font-size-sm);
  font-weight: 600;
}
.mood-change.mood-up   { color: var(--color-success); }
.mood-change.mood-down { color: var(--color-danger); }
.mood-change.mood-same { color: var(--text-muted); }

/* --- Traffic-light indicator (SafetySystem) --- */
.traffic-light {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: var(--space-2);
}
.traffic-light.green  { background: var(--color-success); }
.traffic-light.yellow { background: var(--color-warning); }
.traffic-light.red    { background: var(--color-danger); }

/* --- Week grid (WeekPlanning / MonthPlanning) --- */
.week-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: var(--space-4);
}

/* --- Limits grouped view --- */
.limits-grouped { display: flex; flex-direction: column; gap: var(--space-4); }
.limits-group h3 { margin-bottom: var(--space-2); font-size: var(--font-size-lg); color: var(--text-primary); }

/* --- Status displays --- */
.status-display {
  padding: var(--space-3) var(--space-4);
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-4);
}
.status-display .label { color: var(--text-muted); font-size: var(--font-size-xs); text-transform: uppercase; margin-bottom: var(--space-1); }
.status-display .value { font-size: var(--font-size-lg); font-weight: 700; color: var(--text-primary); }

/* --- Sub-table (nested table sections) --- */
.sub-table-container { padding: var(--space-3); }
.sub-table { width: 100%; border-collapse: collapse; font-size: var(--font-size-xs); }
.sub-table td { padding: var(--space-1) var(--space-2); color: var(--text-secondary); }
.sub-row { background: rgba(255,255,255,0.02); }

/* --- Detail row (used in Aftercare, Protocols, etc.) --- */
.detail-row { font-size: var(--font-size-sm); color: var(--text-secondary); padding: var(--space-1) 0; }
.detail-row strong { color: var(--text-primary); margin-right: var(--space-2); }

/* --- Tab bar / Filter bar --- */
.tab-bar {
  display: flex;
  gap: var(--space-2);
  margin-bottom: var(--space-5);
  border-bottom: 1px solid var(--border-subtle);
  padding-bottom: var(--space-2);
  flex-wrap: wrap;
}
.tab-bar button {
  padding: var(--space-2) var(--space-4);
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  font-size: var(--font-size-sm);
  border-bottom: 2px solid transparent;
  transition: color 0.15s, border-color 0.15s;
}
.tab-bar button.active,
.tab-bar button:hover {
  color: var(--text-primary);
  border-bottom-color: var(--color-primary);
}

/* --- Header actions (page header with title + buttons) --- */
.header-actions { display: flex; gap: var(--space-2); flex-wrap: wrap; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--space-6); flex-wrap: wrap; gap: var(--space-3); }

/* --- Filter bar (inline search + filter selects) --- */
.filter-bar {
  display: flex;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  flex-wrap: wrap;
  align-items: center;
}
.filter-bar input,
.filter-bar select {
  padding: var(--space-2) var(--space-3);
  background: var(--surface-3);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  min-height: 2.25rem;
}
.filter-bar input:focus,
.filter-bar select:focus { border-color: var(--color-primary); outline: none; }

/* --- Checkbox label (inline checkboxes in forms) --- */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  cursor: pointer;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}
.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--color-primary);
  cursor: pointer;
}

/* --- Group header (used for grouped lists like Routines, SpeechRules) --- */
.group-header {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text-primary);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--border-subtle);
  margin-bottom: var(--space-3);
}

/* --- Icon-sized action buttons (table row actions) --- */
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-1);
  background: transparent;
  border: none;
  color: var(--text-muted);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: var(--font-size-sm);
}
.icon-btn:hover { color: var(--text-primary); background: var(--surface-hover); }
.icon-btn.edit { color: var(--color-primary); }
.icon-btn.delete { color: var(--color-danger); }

/* --- Table thumbnail (Media, etc.) --- */
.table-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  background: var(--surface-3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/shared.css"],"names":[],"mappings":"AAAA;;;;sEAIsE;;AAEtE;EACE,UAAU;EACV,+BAA+B;EAC/B,+BAA+B;EAC/B,gDAAgD;;EAEhD,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,aAAa;EACb,oBAAoB,WAAW,WAAW;EAC1C,oBAAoB,WAAW,UAAU;EACzC,oBAAoB,WAAW,WAAW;EAC1C,oBAAoB,WAAW,WAAW;EAC1C,wBAAwB;;EAExB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;;EAE1C,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;;EAEf,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;;EAE3C,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;;EAExB,eAAe;EACf,gDAAgD;AAClD;;AAEA;;sEAEsE;AACtE;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;;;;EAKE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;;sEAGsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,2EAA2E;EAC3E,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA,qBAAqB,gCAAgC,EAAE,WAAW,EAAE;AACpE,0CAA0C,sCAAsC,EAAE;AAClF,qBAAqB,gCAAgC,EAAE,WAAW,EAAE;AACpE,0CAA0C,sCAAsC,EAAE;AAClF,qBAAqB,+BAA+B,EAAE,WAAW,EAAE;AACnE,0CAA0C,qCAAqC,EAAE;AACjF,qBAAqB,4BAA4B,EAAE,0BAA0B,EAAE;AAC/E,0CAA0C,gCAAgC,EAAE;AAC5E,qBAAqB,uBAAuB,EAAE,4BAA4B,EAAE;AAC5E,0CAA0C,gCAAgC,EAAE,0BAA0B,EAAE;AACxG,qBAAqB,sCAAsC,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAClH,qBAAqB,sCAAsC,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAClH,qBAAqB,WAAW,EAAE;;AAElC;;sEAEsE;AACtE;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;EAC5B,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,0BAA0B;EAC1B,mBAAmB;AACrB;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,gCAAgC,oCAAoC,EAAE;AACtE,2BAA2B,mBAAmB,EAAE,SAAS,EAAE;;AAE3D;EACE,oBAAoB,aAAa,EAAE;EACnC;IACE,cAAc;IACd,uBAAuB;IACvB,6CAA6C;EAC/C;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;;AAEA;;sEAEsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,aAAa;AACf;AACA,+BAA+B,gBAAgB,EAAE,gBAAgB,EAAE;AACnE;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;;sEAEsE;AACtE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,0BAA0B,8BAA8B,EAAE,0BAA0B,EAAE;AACtF;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sCAAsC;EACtC,+BAA+B;AACjC;AACA,4BAA4B,0BAA0B,EAAE,gCAAgC,EAAE;AAC1F;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;sEAEsE;AACtE;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,2CAA2C;EAC3C,+BAA+B;EAC/B,sCAAsC;EACtC,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;AACA,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,sCAAsC,EAAE;AACzD,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,oCAAoC,EAAE;AACvD,iBAAiB,SAAO,EAAE,8BAA8B,EAAE,iBAAiB,EAAE;AAC7E;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA,qBAAqB,0BAA0B,EAAE;;AAEjD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,SAAS;IACT,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;EACA,SAAS,eAAe,EAAE;AAC5B;;AAEA;;sEAEsE;AACtE;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;;EAEE,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;sEAEsE;AACtE;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;sEAEsE;AACtE;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,UAAU,EAAE,YAAY;EACxB,gBAAgB,EAAE,sBAAsB;EACxC,mBAAmB,EAAE,SAAS;AAChC;;AAEA;;;;sEAIsE;;AAEtE,wCAAwC;AACxC,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AAC9E,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACvH,aAAa,SAAO,EAAE,gBAAgB,EAAE;AACxC,cAAc,8BAA8B,EAAE,wBAAwB,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACvH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA,yBAAyB,2BAA2B,EAAE;AACtD,yBAAyB,0BAA0B,EAAE;AACrD,yBAAyB,wBAAwB,EAAE;;AAEnD,mDAAmD;AACnD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA,wBAAwB,gCAAgC,EAAE;AAC1D,wBAAwB,gCAAgC,EAAE;AAC1D,wBAAwB,+BAA+B,EAAE;;AAEzD,qDAAqD;AACrD;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AAC9E,mBAAmB,6BAA6B,EAAE,8BAA8B,EAAE,0BAA0B,EAAE;;AAE9G,4BAA4B;AAC5B;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA,yBAAyB,wBAAwB,EAAE,8BAA8B,EAAE,yBAAyB,EAAE,6BAA6B,EAAE;AAC7I,yBAAyB,8BAA8B,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEvG,8CAA8C;AAC9C,uBAAuB,uBAAuB,EAAE;AAChD,aAAa,WAAW,EAAE,yBAAyB,EAAE,8BAA8B,EAAE;AACrF,gBAAgB,sCAAsC,EAAE,4BAA4B,EAAE;AACtF,WAAW,kCAAkC,EAAE;;AAE/C,4DAA4D;AAC5D,cAAc,8BAA8B,EAAE,4BAA4B,EAAE,yBAAyB,EAAE;AACvG,qBAAqB,0BAA0B,EAAE,4BAA4B,EAAE;;AAE/E,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,6CAA6C;EAC7C,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,8BAA8B;EAC9B,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;;EAEE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,8DAA8D;AAC9D,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvE,eAAe,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,6BAA6B,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAExJ,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;2BAC2B,kCAAkC,EAAE,aAAa,EAAE;;AAE9E,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,eAAe;EACf,8BAA8B;AAChC;AACA,kBAAkB,0BAA0B,EAAE,gCAAgC,EAAE;AAChF,iBAAiB,2BAA2B,EAAE;AAC9C,mBAAmB,0BAA0B,EAAE;;AAE/C,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;AAC9B","sourcesContent":["/* =================================================================\n * Shared design tokens + utility classes\n * Loaded globally from index.js. Defines CSS custom properties so we\n * can stop hard-coding colors/spacing/typography per page.\n * ================================================================= */\n\n:root {\n  /* Brand */\n  --color-primary:        #5865F2;\n  --color-primary-hover:  #4752c4;\n  --color-primary-soft:   rgba(88, 101, 242, 0.15);\n\n  /* Semantic */\n  --color-success:        #43b581;\n  --color-success-hover:  #3ca374;\n  --color-warning:        #faa61a;\n  --color-danger:         #ef4444;\n  --color-danger-hover:   #dc2626;\n  --color-info:           #00b0f4;\n\n  /* Surfaces */\n  --surface-0: #0f0f1e;          /* app bg */\n  --surface-1: #16213e;          /* cards */\n  --surface-2: #1a1a2e;          /* modals */\n  --surface-3: #23233a;          /* inputs */\n  --surface-hover: #2a2a45;\n\n  /* Text */\n  --text-primary:   #ffffff;\n  --text-secondary: #b9b9c8;\n  --text-muted:     #8b8b9a;\n\n  /* Borders */\n  --border-subtle: rgba(255, 255, 255, 0.08);\n  --border-strong: rgba(255, 255, 255, 0.16);\n\n  /* Spacing scale */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n\n  /* Radii */\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n\n  /* Shadows */\n  --shadow-sm: 0 2px 6px rgba(0, 0, 0, 0.18);\n  --shadow-md: 0 4px 14px rgba(0, 0, 0, 0.28);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.38);\n\n  /* Typography */\n  --font-size-xs:  0.75rem;\n  --font-size-sm:  0.875rem;\n  --font-size-md:  1rem;\n  --font-size-lg:  1.125rem;\n  --font-size-xl:  1.5rem;\n  --font-size-2xl: 1.75rem;\n\n  /* Focus ring */\n  --focus-ring: 0 0 0 3px rgba(88, 101, 242, 0.45);\n}\n\n/* =================================================================\n * Focus visible — keyboard navigation needs to be visible\n * ================================================================= */\n*:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring);\n  border-radius: 4px;\n}\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n\n/* =================================================================\n * Buttons — consolidated; legacy page-specific styles may still\n * override, which is fine during gradual migration.\n * ================================================================= */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease, transform 0.05s ease;\n  min-height: 2.25rem;\n}\n.btn:disabled,\n.btn[aria-disabled=\"true\"] {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.btn-primary       { background: var(--color-primary); color: #fff; }\n.btn-primary:hover:not(:disabled)       { background: var(--color-primary-hover); }\n.btn-success       { background: var(--color-success); color: #fff; }\n.btn-success:hover:not(:disabled)       { background: var(--color-success-hover); }\n.btn-danger        { background: var(--color-danger); color: #fff; }\n.btn-danger:hover:not(:disabled)        { background: var(--color-danger-hover); }\n.btn-secondary     { background: var(--surface-3); color: var(--text-primary); }\n.btn-secondary:hover:not(:disabled)     { background: var(--surface-hover); }\n.btn-ghost         { background: transparent; color: var(--text-secondary); }\n.btn-ghost:hover:not(:disabled)         { background: var(--surface-hover); color: var(--text-primary); }\n.btn-sm            { padding: var(--space-1) var(--space-3); font-size: var(--font-size-xs); min-height: 1.75rem; }\n.btn-lg            { padding: var(--space-3) var(--space-6); font-size: var(--font-size-md); min-height: 2.75rem; }\n.btn-block         { width: 100%; }\n\n/* =================================================================\n * Shared data-table — previously used in 8+ pages but never defined.\n * ================================================================= */\n.data-table-container {\n  background: var(--surface-1);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: var(--space-6);\n}\n.data-table-container > .data-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-sm);\n}\n.data-table thead th {\n  background: rgba(0, 0, 0, 0.25);\n  text-align: left;\n  padding: var(--space-3) var(--space-4);\n  font-weight: 600;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border-subtle);\n  white-space: nowrap;\n}\n.data-table tbody td {\n  padding: var(--space-3) var(--space-4);\n  border-bottom: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n  vertical-align: top;\n}\n.data-table tbody tr:last-child td { border-bottom: none; }\n.data-table tbody tr:hover td { background: rgba(88, 101, 242, 0.05); }\n.data-table .col-actions { white-space: nowrap; width: 1%; }\n\n@media (max-width: 768px) {\n  .data-table thead { display: none; }\n  .data-table tbody tr {\n    display: block;\n    padding: var(--space-3);\n    border-bottom: 1px solid var(--border-subtle);\n  }\n  .data-table tbody td {\n    display: flex;\n    justify-content: space-between;\n    padding: var(--space-2) 0;\n    border: none;\n  }\n  .data-table tbody td::before {\n    content: attr(data-label);\n    color: var(--text-muted);\n    font-weight: 600;\n    margin-right: var(--space-4);\n  }\n}\n\n/* =================================================================\n * Shared form controls — used as a baseline for new pages.\n * ================================================================= */\n.shared-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  margin-bottom: var(--space-4);\n}\n.shared-form-label {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n.shared-form-control {\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  background: var(--surface-3);\n  color: var(--text-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-family: inherit;\n  min-height: 2.25rem;\n}\n.shared-form-control:focus {\n  border-color: var(--color-primary);\n  outline: none;\n}\ntextarea.shared-form-control { min-height: 6rem; resize: vertical; }\n.shared-form-error {\n  color: var(--color-danger);\n  font-size: var(--font-size-xs);\n  margin-top: var(--space-1);\n}\n.shared-form-hint {\n  color: var(--text-muted);\n  font-size: var(--font-size-xs);\n}\n.shared-form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--space-4);\n}\n\n/* =================================================================\n * Shared modal — for pages that don't have bespoke modal CSS.\n * ================================================================= */\n.shared-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--space-4);\n  animation: sharedModalFadeIn 0.15s ease-out;\n}\n.shared-modal {\n  background: var(--surface-2);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  width: 100%;\n  max-width: 640px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  padding: var(--space-6);\n}\n.shared-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-5);\n}\n.shared-modal-header h2 { font-size: var(--font-size-xl); color: var(--text-primary); }\n.shared-modal-close {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 1.5rem;\n  line-height: 1;\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-sm);\n}\n.shared-modal-close:hover { color: var(--text-primary); background: var(--surface-hover); }\n.shared-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-3);\n  margin-top: var(--space-5);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-subtle);\n}\n.shared-form-error-banner {\n  background: rgba(239, 68, 68, 0.12);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  color: #fecaca;\n  padding: var(--space-3);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-4);\n  font-size: var(--font-size-sm);\n}\n\n@keyframes sharedModalFadeIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* =================================================================\n * Toast system\n * ================================================================= */\n.toast-container {\n  position: fixed;\n  top: var(--space-6);\n  right: var(--space-6);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  z-index: 2000;\n  pointer-events: none;\n  max-width: calc(100vw - var(--space-6) * 2);\n}\n.toast {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  background: var(--surface-2);\n  color: var(--text-primary);\n  border-left: 4px solid var(--color-primary);\n  border-radius: var(--radius-md);\n  padding: var(--space-3) var(--space-4);\n  box-shadow: var(--shadow-lg);\n  pointer-events: auto;\n  min-width: 260px;\n  max-width: 460px;\n  animation: toastSlideIn 0.18s ease-out;\n}\n.toast-success { border-left-color: var(--color-success); }\n.toast-error   { border-left-color: var(--color-danger); }\n.toast-warning { border-left-color: var(--color-warning); }\n.toast-info    { border-left-color: var(--color-info); }\n.toast-message { flex: 1; font-size: var(--font-size-sm); line-height: 1.35; }\n.toast-close {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 1.25rem;\n  line-height: 1;\n  padding: 0 var(--space-1);\n}\n.toast-close:hover { color: var(--text-primary); }\n\n@keyframes toastSlideIn {\n  from { opacity: 0; transform: translateX(16px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@media (max-width: 768px) {\n  .toast-container {\n    top: auto;\n    bottom: var(--space-4);\n    right: var(--space-4);\n    left: var(--space-4);\n  }\n  .toast { max-width: none; }\n}\n\n/* =================================================================\n * ErrorBoundary + 404\n * ================================================================= */\n.error-boundary,\n.not-found-page {\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-8);\n}\n.error-boundary-inner,\n.not-found-inner {\n  max-width: 560px;\n  text-align: center;\n  background: var(--surface-1);\n  padding: var(--space-8);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-subtle);\n}\n.error-boundary-inner h1,\n.not-found-inner h1 {\n  font-size: var(--font-size-2xl);\n  margin-bottom: var(--space-4);\n  color: var(--text-primary);\n}\n.error-boundary-inner p,\n.not-found-inner p {\n  color: var(--text-secondary);\n  margin-bottom: var(--space-5);\n  line-height: 1.5;\n}\n.error-boundary-inner details {\n  margin: var(--space-4) 0;\n  text-align: left;\n}\n.error-boundary-inner summary {\n  cursor: pointer;\n  color: var(--text-muted);\n  font-size: var(--font-size-sm);\n}\n.error-boundary-inner pre {\n  background: var(--surface-0);\n  padding: var(--space-3);\n  border-radius: var(--radius-sm);\n  overflow-x: auto;\n  font-size: var(--font-size-xs);\n  margin-top: var(--space-2);\n  color: var(--text-secondary);\n}\n\n/* =================================================================\n * Utility — inline error text under forms\n * ================================================================= */\n.inline-error {\n  color: var(--color-danger);\n  font-size: var(--font-size-sm);\n  margin-top: var(--space-2);\n}\n.inline-success {\n  color: var(--color-success);\n  font-size: var(--font-size-sm);\n  margin-top: var(--space-2);\n}\n\n/* =================================================================\n * Page-level empty / loading state helpers\n * ================================================================= */\n.page-empty-state {\n  text-align: center;\n  padding: var(--space-8);\n  color: var(--text-muted);\n  background: var(--surface-1);\n  border-radius: var(--radius-lg);\n  border: 1px dashed var(--border-subtle);\n}\n.page-loading-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3);\n  padding: var(--space-8);\n  color: var(--text-muted);\n}\n\n/* Accessible visually-hidden helper for screen readers */\n.visually-hidden {\n  position: absolute;\n  width: 1px; height: 1px;\n  padding: 0; margin: -1px;\n  overflow: hidden; clip: rect(0, 0, 0, 0);\n  white-space: nowrap; border: 0;\n}\n\n/* =================================================================\n * Styles used by the 18 pages without dedicated CSS files.\n * These ensure the pages render consistently even though they\n * don't import their own stylesheet.\n * ================================================================= */\n\n/* --- Aftercare / Mood comparison --- */\n.aftercare-list { display: flex; flex-direction: column; gap: var(--space-4); }\n.mood-comparison { display: flex; align-items: center; gap: var(--space-3); flex-wrap: wrap; margin: var(--space-3) 0; }\n.mood-item { flex: 1; min-width: 100px; }\n.mood-label { font-size: var(--font-size-xs); color: var(--text-muted); display: block; margin-bottom: var(--space-1); }\n.mood-change-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-1) var(--space-2);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n}\n.mood-change.mood-up   { color: var(--color-success); }\n.mood-change.mood-down { color: var(--color-danger); }\n.mood-change.mood-same { color: var(--text-muted); }\n\n/* --- Traffic-light indicator (SafetySystem) --- */\n.traffic-light {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: var(--space-2);\n}\n.traffic-light.green  { background: var(--color-success); }\n.traffic-light.yellow { background: var(--color-warning); }\n.traffic-light.red    { background: var(--color-danger); }\n\n/* --- Week grid (WeekPlanning / MonthPlanning) --- */\n.week-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: var(--space-4);\n}\n\n/* --- Limits grouped view --- */\n.limits-grouped { display: flex; flex-direction: column; gap: var(--space-4); }\n.limits-group h3 { margin-bottom: var(--space-2); font-size: var(--font-size-lg); color: var(--text-primary); }\n\n/* --- Status displays --- */\n.status-display {\n  padding: var(--space-3) var(--space-4);\n  background: var(--surface-1);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-4);\n}\n.status-display .label { color: var(--text-muted); font-size: var(--font-size-xs); text-transform: uppercase; margin-bottom: var(--space-1); }\n.status-display .value { font-size: var(--font-size-lg); font-weight: 700; color: var(--text-primary); }\n\n/* --- Sub-table (nested table sections) --- */\n.sub-table-container { padding: var(--space-3); }\n.sub-table { width: 100%; border-collapse: collapse; font-size: var(--font-size-xs); }\n.sub-table td { padding: var(--space-1) var(--space-2); color: var(--text-secondary); }\n.sub-row { background: rgba(255,255,255,0.02); }\n\n/* --- Detail row (used in Aftercare, Protocols, etc.) --- */\n.detail-row { font-size: var(--font-size-sm); color: var(--text-secondary); padding: var(--space-1) 0; }\n.detail-row strong { color: var(--text-primary); margin-right: var(--space-2); }\n\n/* --- Tab bar / Filter bar --- */\n.tab-bar {\n  display: flex;\n  gap: var(--space-2);\n  margin-bottom: var(--space-5);\n  border-bottom: 1px solid var(--border-subtle);\n  padding-bottom: var(--space-2);\n  flex-wrap: wrap;\n}\n.tab-bar button {\n  padding: var(--space-2) var(--space-4);\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n  border-bottom: 2px solid transparent;\n  transition: color 0.15s, border-color 0.15s;\n}\n.tab-bar button.active,\n.tab-bar button:hover {\n  color: var(--text-primary);\n  border-bottom-color: var(--color-primary);\n}\n\n/* --- Header actions (page header with title + buttons) --- */\n.header-actions { display: flex; gap: var(--space-2); flex-wrap: wrap; }\n.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--space-6); flex-wrap: wrap; gap: var(--space-3); }\n\n/* --- Filter bar (inline search + filter selects) --- */\n.filter-bar {\n  display: flex;\n  gap: var(--space-3);\n  margin-bottom: var(--space-5);\n  flex-wrap: wrap;\n  align-items: center;\n}\n.filter-bar input,\n.filter-bar select {\n  padding: var(--space-2) var(--space-3);\n  background: var(--surface-3);\n  color: var(--text-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  min-height: 2.25rem;\n}\n.filter-bar input:focus,\n.filter-bar select:focus { border-color: var(--color-primary); outline: none; }\n\n/* --- Checkbox label (inline checkboxes in forms) --- */\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n.checkbox-label input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--color-primary);\n  cursor: pointer;\n}\n\n/* --- Group header (used for grouped lists like Routines, SpeechRules) --- */\n.group-header {\n  font-size: var(--font-size-md);\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: var(--space-3) 0;\n  border-bottom: 1px solid var(--border-subtle);\n  margin-bottom: var(--space-3);\n}\n\n/* --- Icon-sized action buttons (table row actions) --- */\n.icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-1);\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n}\n.icon-btn:hover { color: var(--text-primary); background: var(--surface-hover); }\n.icon-btn.edit { color: var(--color-primary); }\n.icon-btn.delete { color: var(--color-danger); }\n\n/* --- Table thumbnail (Media, etc.) --- */\n.table-thumb {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n  background: var(--surface-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
